<template>
    <div class="modal modal-save-container is-active" :class="[!getShowPdfModal ? 'fade-out': 'slide-in-fwd-center']">
    <div class="modal-background faded"></div>
      <div class="modal-content" v-clickoutside="handleClose">
        <div class="modal-box modal-save columns is-multiline">
          <button class="modal-close is-large" @click="handleClose()" aria-label="close"></button>
          <div class="column is-12 modal-save-column flex-center">

            <!-- Spinner -->

            <div v-if="showFeedback" :class="{'fade-in': showFeedback}" class="column is-12 sdg-graphic-container">
              <div class="flex-center">
                <icon class="save-spinner-svg flex sdg-spinner" name="sdg-wheel"></icon>
              </div>
            </div>

            <!-- Loading done -->
            <div v-else class="columns is-multiline">
              <div class="column is-12 sdg-graphic-container flex-center">
                <div class="rotate-in-center">
                  <div class="saved-checkmark-circle flex-center">
                    <icon class="large-svg flex fill-green" name="checkmark"></icon>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-12 flex-center">
            <div class="columns is-multiline">
              <div v-if="showFeedback" class="column is-12 flex-center fade-in">
                <span class="spinner-feedback-text">
                  {{$t('modal-pdf.spinnerFeedbackText')}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import clickoutside from './../../../mixins/shared/clickoutside.js'

export default {
  name: 'modal-pdf',
  directives: { clickoutside },
  data () {
    return {
      showFeedback: false,
      closeModal: false
    }
  },
  computed: {
    ...mapGetters({
      getShowPdfModal: 'getShowPdfModal'
    })
  },
  methods: {
    ...mapActions({
      setShowPdfModal: 'setShowPdfModal'
    }),
    handleClose ($event, el) {
      if (this.getShowPdfModal && this.closeModal) {
        this.setShowPdfModal(false)
        this.showFeedback = false
      }
    }
  },
  watch: {
    getShowPdfModal (val, oldVal) {
      if (val) {
        this.closeModal = true
        this.showFeedback = true
      } else {
        this.closeModal = false
        this.showFeedback = false
      }
    //   if (val !== oldVal && this.getShowPdfModal) {
    //     this.$nextTick(() => {
    //       this.closeModal = true
    //     })
    //   } else {
    //     this.closeModal = false
    //   }
    }
  }
}
</script>
